// @ts-ignore: allow side-effect CSS import without type declarations

import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ConfigProvider, App as AntdApp } from "antd";
// import Homepage from "./website/homepage/homepage";
import About from "./website/about/about";
import Contact from "./website/contact/contact";
import Blogpage from "./website/blogpage/blogpage";
import Blog1 from "./website/blogpage/bolgpages/blog1";
import Blog2 from "./website/blogpage/bolgpages/blog2";
import Blog3 from "./website/blogpage/bolgpages/blog3";
import Blog4 from "./website/blogpage/bolgpages/blog4";
import Blog5 from "./website/blogpage/bolgpages/blog5";
import Blog6 from "./website/blogpage/bolgpages/blog6";
import Blog7 from "./website/blogpage/bolgpages/blog7";
import AdminNavigation from "./adminnavigation";
import { Provider } from "react-redux";
import store from "./redux/store";
import Coursepage from "./website/course/coursepage";
import CourseDetails from "./website/course/viewCourseDetails";
import PrivacyPolicy from "./website/componets/policiespage/privacypolicy";
import Login from "./admin/loginadmin/login";
import RefundPolicy from "./website/componets/policiespage/refundPolicy";
import Accreditations from "./website/componets/Accreditations/Accreditations";
import Blog8 from "./website/blogpage/bolgpages/blog8";
import Blog9 from "./website/blogpage/bolgpages/blog9";
import { lazy, Suspense } from "react";
import Blog10 from "./website/blogpage/bolgpages/blog10";
import Blog11 from "./website/blogpage/bolgpages/blog11";
import Blog12 from "./website/blogpage/bolgpages/blog12";
import Blog13 from "./website/blogpage/bolgpages/blog13";

const Homepage = lazy(() => import("./website/homepage/homepage"));

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={{ token: { colorPrimary: "#FF1A1A" } }}>
        <AntdApp>
          <Router>
            <Routes>

              <Route path="/" element={<Homepage />} />
              <Route path="/admin" element={<Login />} />
              <Route path="/admin/*" element={<AdminNavigation />} />
              <Route
                path="/"
                element={
                  <Suspense fallback={null}>
                    <Homepage />
                  </Suspense>
                }
              />
              <Route path="/about-us" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/course" element={<Coursepage />} />
              <Route path="/course/category/:id" element={<Coursepage />} />
              <Route path="/course/:id" element={<CourseDetails />} />
              <Route path="/blogs" element={<Blogpage />} />
              <Route path="/blog1" element={<Blog1 />} />
              <Route path="/blog2" element={<Blog2 />} />
              <Route path="/blog3" element={<Blog3 />} />
              <Route path="/blog4" element={<Blog4 />} />
              <Route path="/blog5" element={<Blog5 />} />
              <Route path="/blog6" element={<Blog6 />} />
              <Route path="/blog7" element={<Blog7 />} />
              <Route path="/blog8" element={<Blog8 />} />
              <Route path="/blog9" element={<Blog9 />} />
              <Route path="/blog10" element={<Blog10 />} />
              <Route path="/blog11" element={<Blog11 />} />
              <Route path="/blog12" element={<Blog12 />} />
              <Route path="/blog13" element={<Blog13 />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/refund" element={<RefundPolicy />} />
              {/* <Route path="/cfe" element={<Cfe />} /> */}

              <Route path="/Accreditations" element={<Accreditations />} />
            </Routes>
          </Router>
        </AntdApp>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
